import { BaseApi, Environment } from '@nextroll/ar-base-api';

const alignmentApi = new BaseApi('/alignment/v1/', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

/**
 * Get advertisable users
 * @param advertisableEid The user's associated advertisable EID.
 * @param signal Optional abortController signal to be able to cancel the fetch
 */
export const getAdvertisableUserEmails = async (
    advertisableEid: string,
    signal?: AbortSignal,
): Promise<string[]> => {
    const response = await alignmentApi.get('authorized_users', { advertisable_eid: advertisableEid }, signal);
    return (response?.results || []).map((user: { user_email: string }) => user.user_email);
};

/**
 * Get advertisable users
 * @param advertisableEid The user's associated advertisable EID.
 * @param crm Salesforce or HubSpot
 * @param signal Optional abortController signal to be able to cancel the fetch
 */
export const getCrmUserEmails = async (
    advertisableEid: string,
    crm: 'salesforce' | 'hubspot',
    signal?: AbortSignal,
): Promise<string[]> => {
    const response = await alignmentApi.get(`crm/${crm}/users`, { advertisable_eid: advertisableEid }, signal);
    return (response?.results || []).map((user: { user_email: string }) => user.user_email);
};

export default alignmentApi;
